import { useState, useEffect } from "react"
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Header from "../components/Header";
import UpgradeHistory from "../components/UpgradeHistory";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUpFromBracket } from '@fortawesome/free-solid-svg-icons'
import UpgradeCard from "../components/UpgradeCard";
import { getRate } from '../utils/currencyUtils';
import { useUser } from "../utils/UserContext";

function Upgradeplan() {
  const { user } = useUser();  
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  const [crypto, setCrypto] = useState([]);
  const [fiat, setFiat] = useState([]);
  const [stock, setStock] = useState([]);
  const [assethistory, setAssethistory] = useState([]);
  useEffect(() => {
      fetch(`/coin_list.txt`)
      .then((res) => res.json())
      .then((data) => {
      var coinList = data.data;
      const updatedData = coinList.map((coin, index) => ({
          id: index + 1,
          logo: `https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`,
          name: coin.name,
          type: 'crypto',
          symbol: coin.symbol,
          price: Number(coin.quote.USD.price.toFixed(2)),
          label: <><img src={`https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`} alt={coin.symbol} width="20" /> {coin.symbol}</>,
          value: coin.name,
      }));
      setCrypto(updatedData);
      })
      .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {
    fetch(`/stock_list.txt`)
    .then((res) => res.json())
    .then((data) => {
    const stockList = Object.values(data);
    const updatedData = stockList.map((stock, index) => ({
        id: index + 1,
        logo: `https://images.financialmodelingprep.com/symbol/${stock.symbol}.png`,
        name: stock.name,
        type: 'stock',
        symbol: stock.symbol,
        price: Number(stock.price.toFixed(2)),
    }));
    setStock(updatedData);
    })
    .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {   
      fetch(`/fiat_list.txt`)
      .then((res) => res.json())
      .then((data) => {
        const wantedCurrencies = {
          AUD: 'Australian Dollar',
          CAD: 'Canadian Dollar',
          CHF: 'Swiss Franc',
          CNY: 'Chinese Yuan',
          EUR: 'Euro',
          GBP: 'British Pound',
          INR: 'Indian Rupee',
          JPY: 'Japanese Yen',
          RUB: 'Russian Ruble',
          USD: 'US Dollar',
          ZAR: 'South African Rand'
        };
        const fiatList = Object.entries(data)
          .filter(([code]) => wantedCurrencies.hasOwnProperty(code))
          .map(([code, value], index) => ({
            id: index + 1,
            symbol: code,
            name: wantedCurrencies[code],
            price: Number(value),
            type: 'fiat',
            logo: `https://flagcdn.com/w40/${code.slice(0, 2).toLowerCase()}.png`,
          }));
        
        setFiat(fiatList);
      })
      .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {
    if (!crypto.length && !fiat.length && !stock.length) return;
    const merged = [
      ...crypto,
      ...fiat,
      ...stock
    ];
    setAssethistory(merged);
  }, [crypto, fiat, stock]);
  const [activeTab, setActiveTab] = useState("plans")
  const [rate, setRate] = useState(1);
  const currencyCode = user?.currency;
  useEffect(() => {
    let isMounted = true;
    const fetchRate = async () => {
      const r = await getRate(currencyCode);
      if (isMounted) setRate(r);
    };
    fetchRate();
    return () => { isMounted = false; };
  }, [currencyCode]);
  const [plans, setPlans] = useState([]);
  const [history, setHistory] = useState([]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetch401kPlan: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setPlans(data.plans);
      }
    })
    .catch(err => {
      console.log(err);
        console.error('Error fetching plans!')
    })
  }, [user]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchPlanHistory: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        const updatedTrans = data.trans.map(tx => {
        const coinName = tx.method.split(" - ")[0];
        let logo = null;
        let symbol = null;
        const asset = assethistory.find(asset => asset.name === coinName);
        if (asset) {
            logo = asset.logo;
            symbol = asset.symbol;
        }
        return {
            ...tx,
            logo,
            symbol
        };
        });
        setHistory(updatedTrans);
      }
    })
    .catch(err => {
      console.log(err);
        console.error('Error fetching history!')
    })
  }, [user]);

  return (
    <div className="container-fluid">
      <div className="row g-0">
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="401(k) plans" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar">
          <Header title="401(k) plans" icon={<FontAwesomeIcon icon={faArrowUpFromBracket} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main>
            <div className="row mt-3">
              <div className="col-12">
                <div className="d-flex align-items-center justify-content-between">
                  <h5 className="mb-4 fw-bold text-white ms-2">401(k) Plans</h5>
                  <div className="d-flex align-items-cemter overflow-x-auto mx-2" style={{cursor:'pointer'}}>
                    <h6 className="mb-0 fw-semibold py-2 me-3" style={{color: activeTab === "plans" ? 'white' : 'gray', fontSize: '16px', borderBottom: activeTab === "plans" ? '2px solid #ff6b35' : 'none'}} onClick={() => {setActiveTab("plans");}}>Plans</h6>
                    <h6 className="mb-0 fw-semibold py-2 me-3" style={{color: activeTab === "history" ? 'white' : 'gray', fontSize: '16px', borderBottom: activeTab === "history" ? '2px solid #ff6b35' : 'none'}} onClick={() => {setActiveTab("history");}}>Upgrade history</h6>
                  </div>
                </div>
                {activeTab === "plans" && (
                  <div className="row">
                    {plans.map((plan) => (
                      <div className="col-xxl-3 col-lg-4 col-6 col-12 g-4" key={plan.id}>
                        <UpgradeCard key={plan.id} name={plan.name} max_savings={plan.max_savings} price={plan.amount} employer_match={plan.employer_match} features={plan.features}/>
                      </div>
                    ))}
                  </div>
                )}
                {activeTab === "history" && (
                  <div className="mycard">
                      <div className="table-responsive">
                          <table className="table table-borderless table-dark align-middle">
                              <thead>
                                  <tr className="fs-7">
                                  <th className="fw-normal text-light d-md-table-cell d-none">ID</th>
                                  <th className="fw-normal text-light d-lg-table-cell d-none">Date</th>
                                  <th className="fw-normal text-light">Plan</th>
                                  <th className="fw-normal text-light d-md-table-cell d-none">Method</th>
                                  <th className="fw-normal text-light">Amount</th>
                                  <th className="fw-normal text-light">Status</th>
                                  <th className="fw-normal text-light d-md-none d-table-cell"></th>
                                  </tr>
                              </thead>
                              <tbody style={{fontSize: '14px'}}>
                              {history.length > 0 ? (
                                  history.map((list, index) => (
                                      <UpgradeHistory index={index} history={list}/>
                                  ))
                              ) : (
                                  <tr>
                                      <td className="py-5" colSpan={6}>You have not made any upgrade yet.</td>
                                  </tr>
                              )}
                              </tbody>
                          </table>
                      </div>
                  </div>
                )}
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  )
}

export default Upgradeplan